import { EmergencyList } from "./EmergencyList";

export default EmergencyList;
